import FlowFramework from "./FlowFramework";

/**
 * FlowSheetJs和FlowSheetPHP对标，但js为直接继承
 */
export default class FlowSheet extends FlowFramework{
  constructor(data) {
    super(data);
  }

  /**
   * 条件节点列表
   * @returns {*[]}
   */
  getExclusiveGatewayList(){
    return this.findNodeList('type','exclusiveGateway');
  }

  /**
   * 条件节点列表
   * @param node_id
   * @returns {*[]}
   */
  getExclusiveGatewayPolylineList(node_id){
    return this.findEdgesList('sourceNodeId',node_id);
  }

  /**
   * 获取所有流程线列表（只包含节点）
   * @returns {*[]}
   */
  getAllNodeSequenceList(){
    let node_list=this.getAllNodeSequence();
    let _node_list=[];
    node_list.forEach((node_ids,nodes_item)=>{
      _node_list[nodes_item]=[];
      node_ids.forEach((value,item)=>{
        let node=this.findNode('id',value);
        _node_list[nodes_item][item]={
          id:node.id,
          name:node.text?node.text.value?node.text.value:node.id:node.id,
          type:node.type,
          properties:node.properties,
        };
      })
    })
    return _node_list;
  }

  /**
   * 获取所有流程线列表（包含节点和流程线）
   * @returns {*[]}
   */
  getAllSequenceList(){
    let node_list=this.getAllSequence();
    let _node_list=[];
    node_list.forEach((node_ids,nodes_item)=>{
      _node_list[nodes_item]=[];
      node_ids.forEach((value,item)=>{
        let node=this.find('id',value);
        _node_list[nodes_item][item]={
          id:node.id,
          name:node.text?node.text.value?node.text.value:node.id:node.id,
          type:node.type,
          properties:node.properties,
        };
      })
    })
    return _node_list;
  }

  /**
   * 查询选择的路线(带参数)
   * @param where 节点列表,如['c5a07253-d49e-43e1-b5e7-5fec20512b81','1e19ec92-30cd-403a-b91a-20fef0fc2267']
   * @returns {*[]}
   */
  chooseAllSequenceList(where=[]){
    let node_list=this.chooseAllSequence(where);
    let _node_list=[];
    node_list.forEach((node_ids,nodes_item)=>{
      _node_list[nodes_item]=[];
      node_ids.forEach((value,item)=>{
        let node=this.find('id',value);
        _node_list[nodes_item][item]={
          id:node.id,
          name:node.text?node.text.value?node.text.value:node.id:node.id,
          type:node.type,
          properties:node.properties,
        };
      })
    })
    return _node_list;
  }
}




// WEBPACK FOOTER //
// ./src/components/Admin/Flow/bpmn/lib/FlowSheet.js